import {Component, Injectable, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-firmware',
  templateUrl: './firmware.component.html',
  styleUrls: ['./firmware.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class FirmwareComponent implements OnInit {


  public items: MenuItem[];
  public activeItem: MenuItem;

  public tabsVisible: boolean;

  private readonly navState: any;

  private activeItemIndex: number;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private i18n: TranslocoService) {
    this.tabsVisible = true;
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    this.items = [
      {id: 'firmware', label: 'model.update', icon: 'pi pi-angle-double-up'},
      {id: 'state', label: 'model.state', icon: 'pi pi-info-circle'}
    ];

    this.items.forEach(item => {
      this.i18n.selectTranslate(item.label).subscribe(value => {
        this.itemsChanged();
        item.label = value;
      });
    });

    if (this.navState?.showView) {
      this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
      this.activeItem = this.items[this.activeItemIndex];
    } else {
      this.activeItemIndex = 0;
      this.activeItem = this.items[this.activeItemIndex];
    }
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

  itemsChanged(): void {
    this.tabsVisible = false;
    setTimeout(() => this.tabsVisible = true, 0);
  }

}
